import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";

function handleEditTask(
  milestone: Identifiable<Milestone>,
  nextTask: Boundaries["editTask"]["success"],
): Identifiable<Milestone> {
  if (!nextTask.modifiedElements) {
    return milestone;
  }
  const modifiedElements = nextTask.modifiedElements;
  if (!modifiedElements.milestones) {
    return milestone;
  }
  const index = modifiedElements.milestones.findIndex((m) =>
    m.uuid ? m.uuid === milestone.uuid : false,
  );
  return index === -1
    ? milestone
    : { ...milestone, endDate: modifiedElements.milestones[index].endDate };
}

export { handleEditTask };
